import CreditPointsCard from 'Components/UserManagement/ViewUser/CreditHistory';
import './styles.scss';
import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import assets from "../../../../../Assets";

//redux
import { useDispatch } from "react-redux";
import { fetchCompanyServiceHistory } from "../../../../../Redux/Slices/companyManagementSlice";
import DatePicker from 'Components/Common/DatePicker';
import DropDownBox from 'Components/Common/DropDownBox';

function ServiceHistory() {
    const { id } = useParams();
    const dispatch = useDispatch();

    const [serviceHistoryData, setServiceHistoryData] = useState([]);
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [company, setCompany] = useState(null);
    const [smartSupport, setSmartSupport] = useState(null); 
    const [sortOrder, setSortOrder] = useState("DESC");

    const smartSupportOptions = [
        {
            label: 'All Supports',
            value: '',
            support_name: 'All Supports',
        },
        {
            label: 'Technical Support',
            value: 2,
            support_name: 'Technical Support',
        },
        {
            label: 'Customer Care',
            value: 3,
            support_name: 'Customer Care',
        },
        {
            label: 'Billing Support',
            value: 4,
            support_name: 'Billing Support',
        },
    ];

    useEffect(() => {
        dispatch(
            fetchCompanyServiceHistory({
                data: {
                    id,
                    smart_support: smartSupport?.value || "", 
                    fromDate: fromDate ? formatSendDate(fromDate) : "",
                    toDate: toDate ? formatSendDate(toDate) : "",
                    sortOrder,
                },
                callBack: (value) => {
                    setServiceHistoryData(value.result);
                },
            })
        );
    }, [dispatch, id, company, smartSupport, fromDate, toDate, sortOrder]);

    const handleFromDate = (date) => {
        setFromDate(date ? new Date(date) : null);
    };

    const handleToDate = (date) => {
        setToDate(date ? new Date(date) : null);
    };

    function formatSendDate(dateObj) {
        if (!dateObj) return "";
        const date = new Date(dateObj);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    }

    const handleSortToggle = () => {
        setSortOrder(prev => (prev === "DESC" ? "ASC" : "DESC"));
    };


    return (
        <div className="serviceHistoryContainer">
            <div className="cardsContainer">
                <div className='serviceHistoryHeader'>
                    <h3>Service History<span>
                        <img
                    src={assets.Icons.sort}
                    alt="sort"
                    className="sort-icon"
                    onClick={handleSortToggle}
                    style={{ cursor: "pointer" }}
                  /></span></h3>
                    <div className='filter-div'>
                        <DropDownBox
                            options={smartSupportOptions}
                            placeholder="Smartsupport Option"
                            onChange={(option) => setSmartSupport(option)} // ✅ Fix here
                            value={smartSupport}
                            customStyles={{
                                control: (provided) => ({
                                    ...provided,
                                    border: '0px',
                                    borderBottom: '1px solid grey',
                                    borderRadius: '0',
                                    width: '180px',
                                    boxShadow: 'none',
                                    padding: '5px 3px',
                                    fontFamily: 'Poppins',
                                    marginRight: '20px',
                                    fontSize: '14px',
                                    height: "50px",
                                }),
                                indicatorSeparator: () => ({ display: 'none' }),
                                menu: (provided) => ({
                                    ...provided,
                                    fontFamily: 'Poppins',
                                    fontSize: '14px',
                                }),
                                option: (provided, state) => ({
                                    ...provided,
                                    fontFamily: 'Poppins',
                                    fontSize: '14px',
                                    backgroundColor: state.isFocused ? '#f1f1f1' : 'white',
                                    color: state.isFocused ? 'black' : 'grey',
                                    cursor: 'pointer',
                                }),
                            }}
                        />
                        <DatePicker
                            placeholderText="From Date"
                            selected={fromDate}
                            onChange={handleFromDate}
                            format={"dd-MM-yyyy"}
                        />
                        <DatePicker
                            placeholderText="To Date"
                            selected={toDate}
                            minDate={fromDate}
                            onChange={handleToDate}
                            format={"dd-MM-yyyy"}
                        />
                    </div>
                </div>
                {serviceHistoryData.length > 0 ?
                    serviceHistoryData.map((credit, index) => (
                        <CreditPointsCard
                            bgColor={"white"}
                            key={index}
                            date={new Date(credit?.createdAt).toLocaleDateString('en-GB') ?? "-"}
                            title={credit?.comments || "-"}
                            score={credit?.credit_spend || "-"}
                        />
                    )) :
                    <p style={{ textAlign: 'center', color: 'gray', fontSize: '22px' }}>No data found.</p>
                }
            </div>
        </div>
    );
}

export default ServiceHistory;
